import './carousel-swiper.css'

import SwiperCarouselInstance from 'customs/swiper-carousel'
import { getData } from 'helpers/dom'

class CarouselSwiperCustom extends HTMLElement {
  connectedCallback() {
    // FLICKER FIX: Initialize in connectedCallback instead of constructor
    // This ensures the element is fully attached to DOM before initialization
    const config = JSON.parse(getData('config', this))
    const options = JSON.parse(getData('options', this))

    // Small delay to ensure Swiper library is loaded
    requestAnimationFrame(() => {
      const carousel = new SwiperCarouselInstance(this, options, config)
    })
  }
}

customElements.define('carousel-swiper-custom', CarouselSwiperCustom)
